module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.pdfdata) ? _c('div', [_vm._l((_vm.numPages), function(i) {
    return [(_vm.loaded.indexOf(i) >= 0 || (i >= _vm.currentPage - Number(_vm.offscreenPages) && i <= _vm.currentPage + Number(_vm.offscreenPages))) ? [_c('pdfvuer', {
      key: i,
      ref: 'ref' + i,
      refInFor: true,
      staticClass: "page",
      attrs: {
        "resize": true,
        "src": _vm.pdfdata,
        "page": i,
        "id": i
      }
    })] : [_c('div', {
      key: i,
      style: (_vm.pageStyle),
      attrs: {
        "id": i
      }
    })]]
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71fd2959"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nav1/LazyPdfVuer.vue
// module id = 937
// module chunks = 170